export const scrollToAnimation = (e: any, id: string, offset = 80) => {
  e.preventDefault();

  const root = document.getElementById('root');
  const element = document.getElementById(id);
  if (!element || !root) return;

  const y = element.offsetTop - offset;
  root.scrollTo({ top: y, behavior: 'smooth' });
};
